import { Button, Card, H1, H3, H4, Tag } from "@blueprintjs/core";
import { useEffect, useState } from "react";
import EventsCard from "./EventsCard";
import { Footer } from "./Footer";

export const SiteUnderConstructionCard = () => {
  // Existing states
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Existing images loading
    const image = new Image();
    image.src = "/work-deadline-4.svg";
    image.onload = () => setImageLoaded(true);
  }, []);

  // Return null or loading spinner if images are not loaded
  if (!imageLoaded) {
    return null; // or return a loading spinner or any placeholder content
  }

  return (
      <div className="site-container">
        <div className="container">
          <img
              src="/work-deadline-4.svg"
              alt="Work Deadline"
              className="deadline-image" // Use className for styling
          />
          <H1 className="card-header">РАСПИСАНИЕ МАСТЕР-КЛАССОВ</H1>
          <div className="row">
            <Card className="card-inside-container" elevation={4}>
              <Tag className="location-tag" large>ПСКОВ</Tag>
              <Tag className="location-product-tag" large intent={"warning"}>СОЛИСТЫ БАЛЕТА TODES</Tag>
              <H3>МАСТЕР-КЛАСС ЭЛЬВИНА БАГИРОВА</H3>
              <H4>16 апреля 2024</H4>
              <p className="event-description">
                Приготовьтесь к потрясающей встрече с харизматичным солистом балета Аллы Духовой TODES. Его темперамент, хореографическое мастерство и любовь к своему делу зарядят мощной энергией! Этот день обещает стать ярким событием для всех любителей танца!
              </p>
              <Button
                  icon="shopping-cart"
                  text="Оформить билет"
                  intent="success"
                  large
                  onClick={() =>
                      (window.location.href =
                          "https://masterclass.todes.ru/event/19PNFT")
                  }
              />
            </Card>
            <Card className="card-inside-container" elevation={4}>
              <Tag className="location-tag" large>ВЕЛИКИЙ НОВГОРОД</Tag>
              <Tag className="location-product-tag" large intent={"warning"}>СОЛИСТЫ БАЛЕТА TODES</Tag>
              <H3>МАСТЕР-КЛАСС ЭЛЬВИНА БАГИРОВА</H3>
              <H4>17 апреля 2024</H4>
              <p className="event-description">
                Приготовьтесь к потрясающей встрече с харизматичным солистом балета Аллы Духовой TODES. Его темперамент, хореографическое мастерство и любовь к своему делу зарядят мощной энергией! Этот день обещает стать ярким событием для всех любителей танца!
              </p>
              <Button
                  icon="shopping-cart"
                  text="Оформить билет"
                  intent="success"
                  large
                  onClick={() =>
                      (window.location.href =
                          "https://masterclass.todes.ru/event/UQU5G9")
                  }
              />
            </Card>
          </div>
        </div>
        {/*<EventsCard/>*/}
        <Footer/>
      </div>
  );
};
